<!-- Container -->
<ng-template #magnifierTemplate>
  <i class="cds-icon-search"></i>
</ng-template>

<div class="container-statement">
  <caixa-webcomponent-navigation-bar />

  <caixa-webcomponent-header-accounts />

  <caixa-webcomponent-main-title text="Histórico de Movimentações" />

  <div class="financial-records-container">
    <div class="time-header">
      <h3>Todos os registros</h3>
      <h6>Última atualização dos registros {{ lastUpdate() | date:'dd/MM/yyyy \'&nbsp;&nbsp;&nbsp; \' HH:mm:ss' }}</h6>
    </div>

    <!-- Filters -->
    <div class="search-row">
      <cds-search-input
        [ngStyle]="{ width: '275px' }"
        [searchValue]="search"
        [placeholder]="'Digite o nome do registro'"
        (inputValue)="financialRecordSearch($event)"
        (clearValue)="financialRecordSearch('')"
      />

      <div>
        @if (!(company.getComponentLoading() | async)) {
          <bfm-active-filters (activeFiltersCount)="activeFiltersCount$.next($event)" />
        }

        <button
          id="financial-records-filter-button"
          class="cds-button s-hollow c-primary"
          [disabled]="company.getComponentLoading() | async"
          (click)="openSidebar()"
        >
          <i class="cds-icon-filter c-icon-medium"></i>
          Filtros

          @if (activeFiltersCount$ | async; as activeFiltersCount) {
            <span class="filter-counter">
              {{ activeFiltersCount }}
            </span>
          }
        </button>
        @if (isDownloadEnabled$ | async) {
          <bfm-download-button
            [contract]="cashFlowContract"
            [filters]="downloadFilters"
          />
        }
      </div>
    </div>
    <!-- ! Filters -->

    <bfm-paginated-financial-list
      [headers]="headers"
      [columnsList]="columnsList"
      [headerClick]="false"
      [bankDetails]="true"
      [statusIcons]="statusIcons"
      [isEditable]="false"
    />

  </div>
</div>
<!-- Container -->
